// import React from 'react';

// function StatCard({ title, value, change, bgColor, icon }) {
//   return (
//     <div
//       className={`p-4 rounded-lg shadow-md ${bgColor} text-white`}
//       style={{
//         height: '150px',
//         backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Ccircle cx='70' cy='70' r='70' fill='%23ffffff' fill-opacity='0.08'/%3E%3Ccircle cx='130' cy='130' r='60' fill='%23000000' fill-opacity='0.15'/%3E%3Ccircle cx='160' cy='60' r='50' fill='%23000000' fill-opacity='0.1'/%3E%3Ccircle cx='40' cy='160' r='40' fill='%23ffffff' fill-opacity='0.1'/%3E%3C/svg%3E")`,
//         backgroundSize: 'cover',
//         backgroundRepeat: 'no-repeat',
//       }}
//     >
//       {/* Icon Section */}
//       <div className="py-1 px-2 rounded bg-white bg-opacity-20 w-10 h-10 flex items-center justify-center">
//         {icon}
//       </div>

//       {/* Title */}
//       <div className="text-md font-semibold mt-4">{title}</div>

//       {/* Value and Change */}
//       <div className="mt-4 flex items-center">
//         <span className="text-2xl font-semibold">{value}</span>
//         <span className="py-1 px-2  text-sm font-medium rounded bg-white bg-opacity-20 text-white  ml-5">
//           {change < 0 ? `${change}%` : `+${change}%`}
//         </span>
//       </div>
//     </div>
//   );
// }

// export default StatCard;
import React from "react";
import { useNavigate } from "react-router-dom";

function StatCard({ title, value, change, bgColor, icon, link }) {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(link)}
      className="p-4 rounded-lg shadow-md bg-white flex flex-col justify-between w-full relative overflow-hidden cursor-pointer transition-transform hover:scale-105"
    >
      {/* Curved Background Decoration */}
      <div
        className="absolute top-0 right-0 w-24 h-20 rounded-bl-full"
        style={{ backgroundColor: bgColor }}
      ></div>

      {/* Icon */}
      <div className="p-2 mb-3 bg-gray-200 rounded-md w-10 h-10 sm:w-8 sm:h-8 flex items-center justify-center relative z-0">
        {icon}
      </div>  

      {/* Title */}
      <div className="mb-3 text-gray-500 text-xs sm:text-sm relative z-0">
        {title}
      </div>

      {/* Value and Change */}
      <div className="flex justify-between items-center relative z-0">
        <span className="text-xl sm:text-2xl font-semibold">{value}</span>
        <span className="px-2 py-1 text-xs sm:text-sm font-medium rounded bg-black text-white">
          {change}%
        </span>
      </div>
    </div>
  );
}

export default StatCard;
